import axiosInstance from 'store/axiosInstance'

export async function downloadFile(blob: any, fileName: string) {
  const url = window.URL.createObjectURL(blob.data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName

  document.body.appendChild(link)

  link.click()

  link.parentNode?.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export async function downloadExcel({
  fileName,
  url,
}: {
  fileName: string
  url: string
}) {
  try {
    axiosInstance.get(url, { responseType: 'arraybuffer' }).then((response: any) => {
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName

      document.body.appendChild(link)

      link.click()

      link.parentNode?.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}
